"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useComboboxInput = void 0;
var _react = require("react");
var _plateCommon = require("@udecode/plate-common");
var _slateReact = require("slate-react");
/* Copied from platejs source */

var useComboboxInput = function useComboboxInput(_ref) {
  var _cursorState$atStart, _cursorState$atEnd;
  var _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
    _ref$cancelInputOnArr = _ref.cancelInputOnArrowLeftRight,
    cancelInputOnArrowLeftRight = _ref$cancelInputOnArr === void 0 ? true : _ref$cancelInputOnArr,
    _ref$cancelInputOnBac = _ref.cancelInputOnBackspace,
    cancelInputOnBackspace = _ref$cancelInputOnBac === void 0 ? true : _ref$cancelInputOnBac,
    _ref$cancelInputOnBlu = _ref.cancelInputOnBlur,
    cancelInputOnBlur = _ref$cancelInputOnBlu === void 0 ? true : _ref$cancelInputOnBlu,
    _ref$cancelInputOnDes = _ref.cancelInputOnDeselect,
    cancelInputOnDeselect = _ref$cancelInputOnDes === void 0 ? true : _ref$cancelInputOnDes,
    _ref$cancelInputOnEsc = _ref.cancelInputOnEscape,
    cancelInputOnEscape = _ref$cancelInputOnEsc === void 0 ? true : _ref$cancelInputOnEsc,
    cursorState = _ref.cursorState,
    _ref$forwardUndoRedoT = _ref.forwardUndoRedoToEditor,
    forwardUndoRedoToEditor = _ref$forwardUndoRedoT === void 0 ? true : _ref$forwardUndoRedoT,
    onCancelInput = _ref.onCancelInput,
    ref = _ref.ref;
  var editor = (0, _plateCommon.useEditorRef)();
  var element = (0, _plateCommon.useElement)();
  var selected = (0, _slateReact.useSelected)();
  var cursorAtStart = (_cursorState$atStart = cursorState === null || cursorState === void 0 ? void 0 : cursorState.atStart) !== null && _cursorState$atStart !== void 0 ? _cursorState$atStart : false;
  var cursorAtEnd = (_cursorState$atEnd = cursorState === null || cursorState === void 0 ? void 0 : cursorState.atEnd) !== null && _cursorState$atEnd !== void 0 ? _cursorState$atEnd : false;
  var removeInput = (0, _react.useCallback)(function () {
    var shouldFocusEditor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var path = (0, _plateCommon.findNodePath)(editor, element);
    if (!path) return;
    (0, _plateCommon.removeNodes)(editor, {
      at: path
    });
    if (shouldFocusEditor) {
      (0, _plateCommon.focusEditor)(editor);
    }
  }, [editor, element]);
  var cancelInput = (0, _react.useCallback)(function () {
    var cause = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'manual';
    var shouldFocusEditor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    removeInput(shouldFocusEditor);
    onCancelInput === null || onCancelInput === void 0 ? void 0 : onCancelInput(cause);
  }, [onCancelInput, removeInput]);

  /**
   * Using autoFocus on the input element causes an error: Cannot resolve a
   * Slate node from DOM node: [object HTMLSpanElement]
   */
  (0, _react.useEffect)(function () {
    if (autoFocus) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
    }
  }, [autoFocus, ref]);

  /**
   * Storing the previous selection lets us determine whether the input has been
   * actively deselected. When undoing or redoing causes a combobox input to be
   * inserted, selected can be temporarily false. Removing the input at this
   * point is incorrect and crashes the editor.
   */
  var previousSelected = (0, _react.useRef)(selected);
  (0, _react.useEffect)(function () {
    if (previousSelected.current && !selected && cancelInputOnDeselect) {
      cancelInput('deselect');
    }
    previousSelected.current = selected;
  }, [selected, cancelInputOnDeselect, cancelInput]);
  return {
    cancelInput: cancelInput,
    props: {
      onBlur: function onBlur() {
        if (cancelInputOnBlur) {
          cancelInput('blur');
        }
      },
      onKeyDown: function onKeyDown(event) {
        if (cancelInputOnEscape && (0, _plateCommon.isHotkey)('escape', event)) {
          cancelInput('escape', true);
        }
        if (cancelInputOnBackspace && cursorAtStart && (0, _plateCommon.isHotkey)('backspace', event)) {
          cancelInput('backspace', true);
        }
        if (cancelInputOnArrowLeftRight && cursorAtStart && (0, _plateCommon.isHotkey)('arrowleft', event)) {
          cancelInput('arrowLeft', true);
        }
        if (cancelInputOnArrowLeftRight && cursorAtEnd && (0, _plateCommon.isHotkey)('arrowright', event)) {
          cancelInput('arrowRight', true);
        }
        var isUndo = _plateCommon.Hotkeys.isUndo(event) && editor.history.undos.length > 0;
        var isRedo = _plateCommon.Hotkeys.isRedo(event) && editor.history.redos.length > 0;
        if (forwardUndoRedoToEditor && (isUndo || isRedo)) {
          event.preventDefault();
          editor[isUndo ? 'undo' : 'redo']();
          (0, _plateCommon.focusEditor)(editor);
        }
      }
    },
    removeInput: removeInput
  };
};
exports.useComboboxInput = useComboboxInput;